import { useState } from "react";
import { Outlet } from "react-router-dom"
import NavBarMain from "../components/NavBarMain"
import Modal from "react-bootstrap/Modal";

export default function LayoutRoot() {
    
    const [notification, setNotification] = useState(null);
    const [prompt, setPrompt] = useState(null);

    function showNotification(type, text) {
        setNotification({ type: type, text: text });
        setTimeout(() => setNotification(null), 3000);
    }

    function showPrompt(title, text, callback, params, cancelCallback, cancelCallbackParams) {
        setPrompt({ title, text, callback, params, cancelCallback, cancelCallbackParams });
    }

    function handlePromptConfirm() {
        if (prompt.callback)
            prompt.callback(prompt.params);

        setPrompt(null);
    }

    function handlePromptCancel() {
        if (prompt.cancelCallback)
            prompt.cancelCallback(prompt.cancelCallbackParams);

        setPrompt(null);
    }

    return (
        <div className="app">
            {
                notification
                    ?
                    <div className={`notification${notification.type === 2 ? " error" : ""}`}>
                        <i className={notification.type === 1 ? "fas fa-check" : "fas fa-exclamation"} ></i> {notification.text}
                    </div >
                    : null
            }
            <Modal show={prompt !== null}>
                <Modal.Header>
                    <Modal.Title>{prompt?.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {prompt?.text}
                </Modal.Body>

                <Modal.Footer className="prompt-footer">
                    <i className="prompt-button prompt-button-confirm fas fa-check" onClick={handlePromptConfirm}><span className="prompt-button-text">CONFIRM</span></i>
                    <i className="prompt-button prompt-button-cancel fas fa-times" onClick={handlePromptCancel}><span className="prompt-button-text">CANCEL</span></i>
                </Modal.Footer>
            </Modal>
            <NavBarMain />
            <main className="app-body">
                <Outlet context={[showNotification, showPrompt]} />
            </main>
        </div >
    );
}